var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMexico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9996 16C31.9996 9.65665 28.308 4.17565 22.9561 1.58765V30.4123C28.308 27.8244 31.9996 22.3434 31.9996 16Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 22.3434 3.69156 27.8244 9.0435 30.4124V1.58765C3.69156 4.17565 0 9.65665 0 16Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.826 16C11.826 18.3051 13.6948 20.1739 16 20.1739C18.3052 20.1739 20.1739 18.3051 20.1739 16V14.6086H11.826V16Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 13.2175H17.3913C17.3913 12.4491 16.7683 11.8262 15.9999 11.8262C15.2316 11.8262 14.6086 12.4491 14.6086 13.2175H10.4347C10.4347 13.9859 11.104 14.6088 11.8723 14.6088H11.826C11.826 15.3772 12.4489 16.0001 13.2173 16.0001C13.2173 16.7685 13.8402 17.3914 14.6086 17.3914H17.3913C18.1597 17.3914 18.7826 16.7685 18.7826 16.0001C19.551 16.0001 20.1739 15.3772 20.1739 14.6088H20.1275C20.8959 14.6088 21.5652 13.9859 21.5652 13.2175Z",
    fill: "#FF9811"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMexico);
export default __webpack_public_path__ + "static/media/flag_mexico.7df4611bc9421dd51ae5778e6bfa4a54.svg";
export { ForwardRef as ReactComponent };